/*
 * @Author: your name
 * @Date: 2020-07-31 11:59:27
 * @LastEditTime: 2020-08-04 12:40:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/store/comp-router.store.js
 */
export const SET_COMP_PAYLOAD = 'SET_COMP_PAYLOAD'
export const CLEAR_COMPROUTER_STORE = 'CLEAR_COMPROUTER_STORE'
export const SET_COMP_VALUE = 'SET_COMP_VALUE'

const compRouterStore = {
  namespaced: true,
  state: {
    compPayload: {
    }
  },
  mutations: {
    [SET_COMP_PAYLOAD](state, compPayload) {
      if (!compPayload.key || !compPayload.widgetConfig) {
        console.warn('compPayload key, widgetConfig is requried')
      } else {
        if (!state.compPayload) {
          state.compPayload = {}
        }
        state.compPayload.activeKey = compPayload.key
        state.compPayload[compPayload.key] = compPayload
      }
    },
    [SET_COMP_VALUE](state, { key, value }) {
      state.compPayload.activeKey = key
      state.compPayload[key] = {
        ...state.compPayload[key],
        value: value,
        dirty: true // 标识是否更改
      }
    },
    [CLEAR_COMPROUTER_STORE](state, key) {
      if (state.compPayload) {
        delete state.compPayload[key]
      }
    }
  }
}

export default compRouterStore
